import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Grid2';
import { useSnackbar } from 'notistack';
import VendorSliderItem from '../shops/components/VendorSliderItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { defaultVariables } from '../../../../config';
import VendorsListSkeleton from "../../../components/loaders/VendorsListSkeleton";
import { CircularProgress } from "@mui/material";
import {ChevronLeft, PackageOpen} from "lucide-react";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import NothingFound from "../../../components/elements/NothingFound";
import {useTranslation} from "react-i18next";
import {addressQueryStringId} from "../../../../config/values";

function VendorsWithFilters({ industry, filters, search = '',setTotal }) {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [vendors, setVendors] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);

    const fetchVendors = async (pageToLoad = 1) => {
        setLoading(true);
        const config = {
            headers: {
                Accept: 'application/json',
            },
            params: {
                page: pageToLoad,
                filters,
                address_id:addressQueryStringId(),
                search
            },
        };
        try {
            const response = await axios.get(`${defaultVariables.url}/front/shops-with-filter/${industry}`, config);
            const newVendors = response.data.data;
            if(!!setTotal) setTotal(response.data.total)
            if(pageToLoad > 1){
                // Append new vendors and ensure uniqueness
                setVendors((prevVendors) => {
                    const mergedVendors = [...prevVendors, ...newVendors];
                    return mergedVendors.filter((v, i, self) =>
                        i === self.findIndex((t) => t.id === v.id)
                    );
                });
            }else{
                setVendors(newVendors);
            }


            // Update `hasMore` based on response
            setHasMore(newVendors.length > 0);
        } catch (error) {
            console.error('Error fetching vendors:', error);
            enqueueSnackbar('Error fetching vendors. Please try again.', { variant: 'error' });
        } finally {
            setLoading(false);
            setInitialLoad(false);
        }
    };

    useEffect(() => {
        setVendors([]);
        setPage(1);
        setHasMore(true);
        setInitialLoad(true);
        fetchVendors(1);
    }, [industry, filters, search]);

    const loadMore = () => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            fetchVendors(nextPage);
        }
    };

    return (
        <>
            {/* Initial Load Skeleton */}
            {initialLoad && (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <VendorsListSkeleton />
                </div>
            )}

            {/* No Vendors Message */}
            {!initialLoad && vendors.length === 0 && !hasMore && (
                <NothingFound
                    type="page"
                    title={t('noVendorFound')}
                    title_color="text"
                    paragraph={t('noVendorFoundTryOtherVendors')}
                    icon={<PackageOpen/>}
                >
                    <Button
                        variant="outlined"
                        startIcon={<ChevronLeft/>}
                        component={Link}
                        to={`/${industry}`}
                    >
                        {t('back')}
                    </Button>
                </NothingFound>
            )}

            {/* Infinite Scroll */}
            {!initialLoad && (
                <InfiniteScroll
                    dataLength={vendors.length}
                    next={loadMore}
                    hasMore={hasMore}
                    loader={(
                        <div style={{ textAlign: 'center', padding: '20px 0' }}>
                            {loading && <CircularProgress />}
                        </div>
                    )}
                >
                    <Grid container spacing={2}>
                        {vendors.map((vendor, index) => (
                            <Grid item size={{xs:12,sm:6,lg:4}} key={index}>
                                <VendorSliderItem vendor={vendor} industry={industry}/>
                            </Grid>
                        ))}
                    </Grid>
                </InfiniteScroll>
            )}
        </>
    );
}

export default VendorsWithFilters;
